<template>
    <div class="screener-header bg-moat-700 mb-md">
        <AonContainer add-page-padding>
            <AonRow>
                <AonCol class="grid-cols-12 screener-tabs__aon-col justify-between p-sm">
                    <div class="display-flex align-items-center">
                        <h5 class="text-stone-0 my-xs">Company Screener</h5>
                    </div>
                </AonCol>
            </AonRow>
        </AonContainer>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const emit = defineEmits(['openSaveAsModal', 'openScreenerModal', 'resetScreener', 'saveScreener'])

const props = defineProps({
    loading: {
        type: Boolean,
        required: true,
    },
    saving: {
        type: Boolean,
        required: true,
    },
    screener: {
        type: Object,
        required: true,
    },
    screenerModified: {
        type: Boolean,
        required: true,
    },
})

const { t } = useI18n()

const actionsDisabled = computed(() => {
    return props.loading || props.saving
})

const openSaveAsModal = (val) => {
    emit('openSaveAsModal', val)
}
const openScreenerModal = (val) => {
    emit('openScreenerModal', val)
}
const resetScreener = (val) => {
    emit('resetScreener', val)
}
const saveScreener = (val) => {
    emit('saveScreener', val)
}
</script>

<style lang="scss" scoped>
.screener-header {
    .a-button {
        &.dark-mode {
            color: var(--color-stone-0);

            &:hover {
                color: var(--color-moat-600-hover);
            }
            &.subtle {
                &.disabled {
                    color: var(--color-stone-200);
                    border: 1px solid var(--color-stone-200);
                }
                &:hover {
                    text-decoration: none;
                    background-color: var(--color-stone-0);
                }
            }
        }
    }
}
</style>
